export default __webpack_public_path__ + "static/media/so.f92a6587.svg";